import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';
import { useAuth } from './AuthContext';

const NotifCtx = createContext({});

export function NotificationProvider({ children }) {
  const { user } = useAuth();
  const [count, setCount] = useState(0);
  const [notifications, setNotifications] = useState([]);

  const fetchCount = useCallback(() => {
    if (!user) return;
    api.get('/notifications/count').then(r => setCount(r.data.count)).catch(() => {});
  }, [user]);

  const fetchAll = useCallback(() => {
    if (!user) return;
    api.get('/notifications', { params: { limit: 20 } }).then(r => setNotifications(r.data)).catch(() => {});
  }, [user]);

  useEffect(() => {
    fetchCount();
    fetchAll();
    const interval = setInterval(fetchCount, 60000);
    return () => clearInterval(interval);
  }, [fetchCount, fetchAll]);

  const markRead = async (id) => {
    await api.put(`/notifications/${id}/read`).catch(() => {});
    setNotifications(prev => prev.map(n => n.id === id ? { ...n, is_read: 1 } : n));
    setCount(c => Math.max(0, c - 1));
  };

  const markAllRead = async () => {
    await api.put('/notifications/read-all').catch(() => {});
    setNotifications(prev => prev.map(n => ({ ...n, is_read: 1 })));
    setCount(0);
  };

  const remove = async (id) => {
    await api.delete(`/notifications/${id}`).catch(() => {});
    setNotifications(prev => prev.filter(n => n.id !== id));
  };

  return (
    <NotifCtx.Provider value={{ count, notifications, fetchAll, markRead, markAllRead, remove, refetch: fetchCount }}>
      {children}
    </NotifCtx.Provider>
  );
}

export function useNotifications() { return useContext(NotifCtx); }
